module.exports = __webpack_public_path__ + "static/media/fax.33bdad39.ico";